import React, { ForwardRefRenderFunction, forwardRef } from "react";
//#region types
import {
  CompactEditableTableFieldProps,
  FormFieldDefinitionType,
  FormHandles,
} from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { FormEnums } from "models/enums";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { TimeReportingFormTypes } from "models/formTypes";
import { MonthlyFormViewProps } from "models/propTypes/timeReportingPropTypes";
import { MonthLongConfig, MonthShortConfig } from "utils/constants/dateConstants";
//#endregion
//#region components
import { GenericForm } from "components/common";
import {
  IconField,
  MonthlyFormTableHeader,
  WeekHoursField,
  ProjectCategoryPickerField,
} from "components/timeReporting";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const MonthlyForm: ForwardRefRenderFunction<FormHandles, MonthlyFormViewProps> = (props, ref) => {
  const { monthLockEntries, weeksInMonth, dateRange, employeeId } = props;

  const monthShort = React.useMemo(
    () => (dateRange?.start ? LocalizationHelperInstance.getFormattedDate(dateRange?.start, MonthShortConfig) : ""),
    [dateRange]
  );

  const getTableRowFields = () => {
    const rowfields = {
      type: {
        label: "",
        type: FormEnums.FormFieldType.CUSTOM,
        customField: <IconField></IconField>,
      },
      name: {
        label: "",
        controlLabel: dateRange?.start
          ? LocalizationHelperInstance.getFormattedDate(dateRange?.start, MonthLongConfig)
          : "",
        type: FormEnums.FormFieldType.CUSTOM,
        customField: <ProjectCategoryPickerField />,
        readonly: true,
        icon: IconDefinitionConstants.WCalendarTime,
        classes: { formControl: cssExports.titleText },
      },
    } as FormFieldDefinitionType<TimeReportingFormTypes.MonthlyTimeReportRow>;

    weeksInMonth?.forEach((week) => {
      (rowfields as any)[week] = {
        label: "-",
        controlLabel: `${week} ${monthShort.toUpperCase()}`,
        rightAlign: true,
        widthColumnCount: 2,
        type: FormEnums.FormFieldType.CUSTOM,
        customField: (
          <WeekHoursField employeeId={employeeId} weekDisplayText={week} monthStart={dateRange?.start}></WeekHoursField>
        ),
      };
    });
    return rowfields;
  };

  return (
    <GenericForm<TimeReportingFormTypes.MonthlyTimeReport>
      formRef={ref}
      {...props}
      fields={{
        rows: {
          label: TranslationKeys.Settings.Units,
          controlLabel: "",
          type: FormEnums.FormFieldType.COMPACTEDITABLETABLE,
          innerFields: getTableRowFields(),
          extraProps: {
            headerRowFieldName: FormFieldConstants.TimeReporting.WeeklyTimeReport.HeaderRow,
            rowHideActions: (row: any) => true,
            externalHeader: (
              <MonthlyFormTableHeader
                innerFields={getTableRowFields()}
                locks={monthLockEntries}
                hideActions
              ></MonthlyFormTableHeader>
            ),
            hideActions: true,
            disableRowSelection: true,
          } as CompactEditableTableFieldProps<TimeReportingFormTypes.MonthlyTimeReportRow>,
        },
      }}
      inline={false}
      hideOptionalIndicator
    />
  );
};

export default forwardRef(MonthlyForm);
